import QueryString from 'query-string';

import { useHistory } from './use-history';

export const useUrlParams = () => {
    const { push, replace } = useHistory();

    function pushParams(param: string, value: string) {
        const url = window.location.href.split('?');

        const parsed = QueryString.parse(location.search);

        parsed[param] = value;

        const stringified = QueryString.stringify(parsed);
        const pageUrl = `${url[0]}?${stringified}`;

        push(pageUrl);
    }

    function replaceParams(param: string, value: string) {
        const url = window.location.href.split('?');

        const parsed = QueryString.parse(location.search);

        parsed[param] = value;

        const stringified = QueryString.stringify(parsed);
        const pageUrl = `${url[0]}?${stringified}`;

        replace(pageUrl);
    }

    function getParams(param: string) {
        const parsed = QueryString.parse(location.search);

        return parsed[param];
    }

    function clearParams() {
        const url = window.location.href.split('?');

        push(url[0]);
    }

    function clearParam(param: string) {
        const url = new URL(document.location.href);
        url.searchParams.delete(param);

        replace(url.toString());
    }

    return {
        replace: replaceParams,
        push: pushParams,
        get: getParams,
        clear: clearParams,
        clearParam,
    };
};
